module.exports = __webpack_public_path__ + "static/media/map.58c94190.svg";